import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const [open, setOpen] = useState(false);
  const [expended, setExpended] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  console.log(drawerOpen, "drawerOpen");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const dropdownRef = useRef(null);

  return (
    <>
      <div class="mouse-cursor cursor-outer"></div>
      <div class="mouse-cursor cursor-inner"></div>
      <header>
        {/*navigation*/}
        <div className="navigation-wrapper w-full h-[90px] border-b border-primaryBorder max-md:px-4">
          <div className="theme-container mx-auto h-full px-0">
            <div className="w-full h-full flex justify-between">
              <div className="h-full flex items-center space-x-[72px] xl:ml-8 sm:ml-5">
                {/*              logo*/}
                <Link to="/">
                  <div className="logo-area w-[240px]">
                    <img
                      src="assets/img/ocd-logo.svg"
                      alt="One Click Doctor"
                      className="w-full h-full object-contain"
                    />
                  </div>
                </Link>
                <nav className="nav-wrapper lg:block hidden">
                  <ul className="flex space-x-7 items-center">
                    <li>
                      <Link to="/" className="">
                        <span>Home</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/plans" className="">
                        <span>Plans</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="" className="">
                        <span>Terms & Policies</span>
                        <span>
                          <svg
                            width={7}
                            height={5}
                            viewBox="0 0 7 5"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="fill-current"
                          >
                            <path d="M3.1377 3.85938L0.637695 1.35938C0.43457 1.17188 0.43457 0.84375 0.637695 0.65625C0.825195 0.453125 1.15332 0.453125 1.34082 0.65625L3.49707 2.79688L5.6377 0.65625C5.8252 0.453125 6.15332 0.453125 6.34082 0.65625C6.54395 0.84375 6.54395 1.17188 6.34082 1.35938L3.84082 3.85938C3.65332 4.0625 3.3252 4.0625 3.1377 3.85938Z" />
                          </svg>
                        </span>
                      </Link>
                      <ul className="sub-menu">
                        <li>
                          <Link to="/term-of-use" className="">
                            <span>Terms Of Use</span>
                          </Link>
                        </li>
                        <li>
                          <Link to="/privacy-policy" className="">
                            <span>Privacy Policy</span>
                          </Link>
                        </li>
                        <li>
                          <Link to="/cancellation-policy" className="">
                            <span>Cancellation Policy</span>
                          </Link>
                        </li>
                        {/* <li>
                          <Link to="/shipping-delivery-policy" className="">
                            <span>Shipping & Delivery Policy</span>
                          </Link>
                        </li> */}
                      </ul>
                    </li>
                    <li>
                      <Link to="/contact" className="">
                        <span>Contact Us</span>
                      </Link>
                    </li>
                  </ul>
                </nav>
                <nav className="nav-wrapper mobile-nav-wrapper block lg:hidden">
                  {drawerOpen && (
                    <div className="">
                      <div
                        className="mobile-wid w-[310px] bg-white fixed top-0 left-0 h-full px-8 pt-10 z-40"
                        style={{ zIndex: 99999 }}
                      >
                        <div className="flex justify-center mb-10">
                          <div className="logo-area w-[180px] h-[55px]">
                            <img
                              src="assets/img/ocd-logo.svg"
                              alt="One Click Doctor"
                              className="w-full h-full object-contain"
                            />
                          </div>
                        </div>
                        <ul className="flex flex-col mb-10">
                          <li>
                            <Link to="/" className="">
                              <span>Home</span>
                            </Link>
                          </li>
                          <li>
                            <Link to="/plans" className="">
                              <span>Plans</span>
                            </Link>
                          </li>
                          <li>
                            <Link to="" className="">
                              <span>Terms & Policies</span>
                              <span>
                                <svg
                                  width={7}
                                  height={5}
                                  viewBox="0 0 7 5"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="fill-current"
                                >
                                  <path d="M3.1377 3.85938L0.637695 1.35938C0.43457 1.17188 0.43457 0.84375 0.637695 0.65625C0.825195 0.453125 1.15332 0.453125 1.34082 0.65625L3.49707 2.79688L5.6377 0.65625C5.8252 0.453125 6.15332 0.453125 6.34082 0.65625C6.54395 0.84375 6.54395 1.17188 6.34082 1.35938L3.84082 3.85938C3.65332 4.0625 3.3252 4.0625 3.1377 3.85938Z" />
                                </svg>
                              </span>
                            </Link>
                            <ul className="sub-menu">
                              <li>
                                <Link to="/term-of-use" className="">
                                  <span>Terms Of Use</span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/privacy-policy" className="">
                                  <span>Privacy Policy</span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/cancellation-policy" className="">
                                  <span>Cancellation Policy</span>
                                </Link>
                              </li>
                              {/* <li>
                                <Link
                                  to="/shipping-delivery-policy"
                                  className=""
                                >
                                  <span>Shipping & Delivery Policy</span>
                                </Link>
                              </li> */}
                            </ul>
                          </li>
                          <li>
                            <Link to="/contact" className="">
                              <span>Contact Us</span>
                            </Link>
                          </li>
                          <li>
                            <Link to="/login.html" target="_blank">
                              Customer Login
                              <svg
                                className="w-6 h-6 ml-8 -mr-2"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="1.5"
                                  d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z"
                                />
                              </svg>
                            </Link>
                          </li>
                          <li>
                            <Link to="https://portal.oneclickdoctor.in/" target="_blank">
                              Agent Login
                              <svg
                                className="w-6 h-6 ml-8 -mr-2"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="1.5"
                                  d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z"
                                />
                              </svg>
                            </Link>
                          </li>
                        </ul>
                      </div>
                      <div
                        onClick={() => setDrawerOpen(false)}
                        className="drawer-away w-full h-full fixed bg-black bg-opacity-80 z-30 left-0 top-0"
                      />
                    </div>
                  )}
                </nav>
              </div>
              <div className="h-full items-center flex">
                <div className="xl:flex hidden items-center mr-6">
                  <span>
                    <svg
                      width={66}
                      height={68}
                      viewBox="0 0 66 68"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M47.8159 16.8074C53.1826 25.1215 47.9291 49.5303 46.7752 54.5301C46.6562 55.0456 46.172 55.3582 45.6532 55.2543C40.6218 54.2471 16.2152 48.9838 10.8484 40.6697C4.85702 31.3878 8.27544 18.5215 18.4837 11.9321C28.692 5.34276 41.8245 7.5255 47.8159 16.8074Z"
                        fill="#e2efff"
                      />
                      <path
                        d="M28.125 23.7812L27.1867 24.127L27.1939 24.1466L27.2019 24.1659L28.125 23.7812ZM29.375 26.7812L28.4519 27.1659L28.4553 27.174L28.4588 27.1821L29.375 26.7812ZM29.0312 28.2188L28.4134 27.4324L28.4013 27.4419L28.3895 27.4518L29.0312 28.2188ZM27.5 29.5L26.8583 28.7331L26.2664 29.2283L26.5955 29.9264L27.5 29.5ZM32.5 34.5L32.0736 35.4045L32.7717 35.7336L33.2669 35.1417L32.5 34.5ZM33.7812 32.9688L34.5482 33.6105L34.5581 33.5987L34.5676 33.5866L33.7812 32.9688ZM35.2188 32.625L34.8179 33.5412L34.826 33.5447L34.8341 33.5481L35.2188 32.625ZM38.2188 33.875L37.8341 34.7981L37.8534 34.8061L37.873 34.8133L38.2188 33.875ZM38.9375 35.3438L39.9023 35.6069L39.9046 35.5982L38.9375 35.3438ZM38.1875 38.0938L39.1469 38.3759L39.1497 38.3664L39.1523 38.3569L38.1875 38.0938ZM23.9062 23.8125L23.6431 22.8477L23.6336 22.8503L23.6241 22.8531L23.9062 23.8125ZM26.6562 23.0625L26.4017 22.0954L26.3931 22.0977L26.6562 23.0625ZM27.2019 24.1659L28.4519 27.1659L30.2981 26.3966L29.0481 23.3966L27.2019 24.1659ZM28.4588 27.1821C28.5082 27.295 28.4672 27.3902 28.4134 27.4324L29.6491 29.0051C30.4703 28.3598 30.6793 27.2675 30.2912 26.3804L28.4588 27.1821ZM28.3895 27.4518L26.8583 28.7331L28.1417 30.2669L29.673 28.9857L28.3895 27.4518ZM26.5955 29.9264C27.7257 32.324 29.676 34.2743 32.0736 35.4045L32.9264 33.5955C30.949 32.6632 29.3368 31.051 28.4045 29.0736L26.5955 29.9264ZM33.2669 35.1417L34.5482 33.6105L33.0143 32.327L31.7331 33.8583L33.2669 35.1417ZM34.5676 33.5866C34.6098 33.5328 34.705 33.4918 34.8179 33.5412L35.6196 31.7088C34.7325 31.3207 33.6402 31.5297 32.9949 32.3509L34.5676 33.5866ZM34.8341 33.5481L37.8341 34.7981L38.6034 32.9519L35.6034 31.7019L34.8341 33.5481ZM37.873 34.8133C37.903 34.8244 37.9318 34.8461 37.9546 34.8945C37.9799 34.9485 37.9886 35.0202 37.9704 35.0893L39.9046 35.5982C40.173 34.5781 39.7085 33.3581 38.5645 32.9367L37.873 34.8133ZM37.9727 35.0806L37.2227 37.8306L39.1523 38.3569L39.9023 35.6069L37.9727 35.0806ZM37.2281 37.8116C37.2086 37.878 37.1725 37.9255 37.1342 37.9551C37.0977 37.9834 37.0539 38 37 38V40C38.0326 40 38.8731 39.3068 39.1469 38.3759L37.2281 37.8116ZM37 38C29.8023 38 24 32.1977 24 25H22C22 33.3023 28.6977 40 37 40V38ZM24 25C24 24.9461 24.0166 24.9023 24.0449 24.8658C24.0745 24.8275 24.122 24.7914 24.1884 24.7719L23.6241 22.8531C22.6932 23.1269 22 23.9674 22 25H24ZM24.1694 24.7773L26.9194 24.0273L26.3931 22.0977L23.6431 22.8477L24.1694 24.7773ZM26.9107 24.0296C26.9798 24.0114 27.0515 24.0201 27.1055 24.0454C27.1539 24.0682 27.1756 24.097 27.1867 24.127L29.0633 23.4355C28.6419 22.2915 27.4219 21.827 26.4018 22.0954L26.9107 24.0296Z"
                        fill="#1B467D"
                      />
                    </svg>
                  </span>
                  <div className="flex flex-col">
                    <span className="spline-sans text-sm text-gray-900 font-medium">
                      Customer Care:
                    </span>
                    <span className="text-base font-bold text-gray-900">
                      (+91) 787-741-0039
                    </span>
                  </div>
                </div>

                {/*  */}
                <nav className="nav-wrapper login-wrapper lg:block hidden">
                  <ul className="flex space-x-7 items-center">
                    <li>
                      <Link
                        to=""
                        target="_blank"
                        className="inline-flex max-md:hidden items-center px-6 py-4 font-semibold !text-white transition-all duration-200 bg-[#1B467D] rounded-full  hover:bg-[#1464A5] focus:bg-[#1464A5]"
                        role="button"
                      >
                        Login
                        <svg
                          className="w-6 h-6 ml-8 -mr-2"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1.5"
                            d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                      </Link>
                      <ul className="sub-menu">
                        <li>
                          <Link to="/login.html" target="_blank" className="">
                            <span>Customer Login</span>
                          </Link>
                        </li>
                        <li>
                          <Link to="https://portal.oneclickdoctor.in/" target="_blank" className="">
                            <span>Agent Login</span>
                          </Link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </nav>

                <button
                  type="button"
                  onClick={() => {
                    setDrawerOpen(!drawerOpen);
                  }}
                  className="openBtn w-[77px] border-1 border-l h-full min-[768px]:hidden flex justify-center items-center"
                >
                  <span className="text-primary-900">
                    <svg
                      width={28}
                      height={22}
                      viewBox="0 0 28 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M28 11H0"
                        stroke="currentColor"
                        strokeWidth={2}
                      />
                      <path
                        d="M21 21H0"
                        stroke="currentColor"
                        strokeWidth={2}
                      />
                      <path d="M20 1H0" stroke="currentColor" strokeWidth={2} />
                    </svg>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
